//================================================================
//  Page: Account 
//================================================================

//  Purpose: Account Menu - Available only in Mobile view

//================================================================

//Libraries
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

//Contexts
import { GetUser } from '../../Library/GlobalContexts';


export default function Account() {

  //------------------------------------------------------
  //  React Router & useContext
  //------------------------------------------------------

  const getUser = useContext(GetUser);

  // Check if user is a demand management admin
  const approverAdmin = getUser?.roles?.demandManagementAdmin === true || getUser?.roles?.commercialAdmin === true;

  //------------------------------------------------------
  //  HTML
  //------------------------------------------------------

  return (

    // Account Menu - Add or remove pages here.
    <div className='p-4'>

      <h4 className='h-10'>Account</h4>

      <div className='flex flex-col gap-4'>

        <Link className='no-underline text-black' to={'/requests'}>
          {/* REQUESTS */}
          <div className='shadow p-3 rounded-md flex flex-col gap-2'>
            <label className='font-semibold'>Requests</label>
            <p>View and manage your requests</p>
          </div>
        </Link>

        <Link className='no-underline text-black' to={'/approvals'}>
          {/* APPROVALS */}
          <div className='shadow p-3 rounded-md flex flex-col gap-2'>
            <label className='font-semibold'>Approvals</label>
            <p>Manage your approvals</p>
          </div>
        </Link>

        {/* Only visible to users with 'demandManagementAdmin' role */}
        {
          approverAdmin && 
          <Link className='no-underline text-black' to={'/admin/approvers'}>
            {/* APPROVERS */}
            <div className='shadow p-3 rounded-md flex flex-col gap-2'>
              <label className='font-semibold'>Admin</label>
              <p>Manage all approvers</p>
            </div>
          </Link>
        }
        
      </div>

    </div>
  )
}